module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.2b72c94.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Roboto/Roboto-Medium.woff
// module id = 171
// module chunks = 245 246